let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2pBDE")).then(() => parcelRequire('cgiou'));